import styled from 'styled-components';

export const ElementContainer = styled.div<{ color?: string }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: top;
  z-index: 0;
  width: 100%;
  border-left: 2px solid
    ${(props) => (props.color ? props.color : props.theme.palette.divider)};
  box-sizing: border-box;
`;

export const VerticalContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  padding-left: 20px;
  box-sizing: border-box;
`;

export const CircleContainer = styled.div`
  padding-right: 25px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  position: relative;
`;
